/**
 * Hook para gestionar la impersonación de asesores
 * Proporciona acceso a estados y funciones relacionadas con la suplantación
 */

import { useAuth } from '@/auth/useAuth';

export function useImpersonation() {
  const { isImpersonating, impersonatedBy, originalUser, user, impersonate, revertImpersonation } = useAuth();

  /**
   * Si el usuario actual puede iniciar una impersonación
   * SYSADMIN o ADMIN pueden iniciarla.
   * Si ya están impersonando, permitimos si el rol actual sigue siendo administrativo (ej: tras switch-to-admin)
   */
  const canImpersonate = user?.asesor?.rol === 'SYSADMIN' || user?.asesor?.rol === 'ADMIN';

  /**
   * Email del asesor siendo suplantado
   */
  const impersonatedEmail = user?.email;

  return {
    /**
     * Si hay una impersonación activa
     */
    isImpersonating,

    /**
     * ID del sysadmin que está suplantando
     */
    impersonatedBy,

    /**
     * Datos del usuario original (sysadmin) guardados antes de impersonar
     */
    originalUser,

    /**
     * Email del asesor siendo suplantado
     */
    impersonatedEmail,

    /**
     * Si el usuario actual puede iniciar una impersonación
     */
    canImpersonate,

    /**
     * Iniciar impersonación de un asesor
     * @param asesorId ID del asesor a suplantar
     */
    impersonate,

    /**
     * Revertir la impersonación y volver a la sesión original
     */
    revertImpersonation,
  };
}
